<form [formGroup]="buyerTinForm" (ngSubmit)="onValidate()" novalidate>
  <div class="grid">
    <!-- Customer Type Dropdown -->
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label for="customerType" class="required">Customer Type</label>
        <p-select
          id="customerType"
          formControlName="customerType"
          [options]="customerTypes"
          optionLabel="label"
          optionValue="value"
          [disabled]="isFormSubmitted"
          (onChange)="updateFormFields($event.value)"
          [class.is-invalid]="
            f['customerType'].touched && f['customerType'].invalid
          "
        ></p-select>
        @if (f['customerType'].touched && f['customerType'].invalid) {
          <div class="p-error">
            Customer Type is required
          </div>
        }
      </div>
    </div>

    <!-- Buyer TIN Available Radio Button -->
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label class="required">Buyer TIN Available</label>
        <div class="p-formgroup-inline">
          <label class="radio-option">
            <p-radioButton
              name="buyerTinAvailable"
              value="yes"
              formControlName="buyerTinAvailable"
              inputId="buyerTinAvailableYes"
              [disabled]="isFormSubmitted"
            ></p-radioButton>
            <span>Yes</span>
          </label>
          <label class="radio-option ms-2">
            <p-radioButton
              name="buyerTinAvailable"
              value="no"
              formControlName="buyerTinAvailable"
              inputId="buyerTinAvailableNo"
              [disabled]="isFormSubmitted"
            ></p-radioButton>
            <span>No</span>
          </label>
        </div>
        @if (f['buyerTinAvailable'].touched && f['buyerTinAvailable'].invalid) {
          <div class="p-error">
            Buyer TIN available is required
          </div>
        }
      </div>
    </div>

    <!-- Buyer TIN Text Field -->
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label for="buyerTin" class="required">Buyer TIN</label>
        <input
          id="buyerTin"
          formControlName="buyerTin"
          pInputText
          [disabled]="isFormSubmitted"
        />
        @if (f['buyerTin'].touched && f['buyerTin'].invalid) {
          <div class="p-error">
            @if (f['buyerTin'].errors?.['required']) {
              <span>Buyer TIN is required</span>
            }

            @if (f['buyerTin'].errors?.['maxLengthExceeded']) {
              <span>Please provide valid Buyer TIN (max 14 characters)</span>
            }
          </div>
        }
        @if (identificationNumberinvalidErrorMessage) {
          <span class="p-error">
            {{ identificationNumberinvalidErrorMessage }}
          </span>
        }
      </div>
    </div>

    <!-- Identification Number Available Radio Button -->
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label class="required">Identification Number Available</label>
        <div class="p-formgroup-inline">
          <label class="radio-option">
            <p-radioButton
              name="identificationNumberAvailable"
              value="yes"
              formControlName="identificationNumberAvailable"
              inputId="identificationNumberAvailableYes"
              [disabled]="isFormSubmitted"
            ></p-radioButton>
            <span>Yes</span>
          </label>
          <label class="radio-option ms-2">
            <p-radioButton
              name="identificationNumberAvailable"
              value="no"
              formControlName="identificationNumberAvailable"
              inputId="identificationNumberAvailableNo"
              [disabled]="isFormSubmitted"
            ></p-radioButton>
            <span>No</span>
          </label>
        </div>
        @if (f['identificationNumberAvailable'].touched && f['identificationNumberAvailable'].invalid) {
          <div class="p-error">
            Identification number available is required
          </div>
        }
      </div>
    </div>

    <!-- Identification Type Dropdown -->
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label for="identificationType" class="required"
          >Identification Type</label
        >
        <p-select
          id="identificationType"
          [options]="filteredIdentificationTypes"
          formControlName="identificationType"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Identification Type"
          [disabled]="isFormSubmitted"
          (onChange)="onIdentificationTypeChange($event)"
          [class.is-invalid]="
            f['identificationType'].touched && f['identificationType'].invalid
          "
        ></p-select>
        @if (f['identificationType'].touched && f['identificationType'].invalid) {
          <div class="p-error">
            Identification Type is required
          </div>
        }
      </div>
    </div>

    <!-- Identification Number Text Field -->
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label for="identificationNumber" class="required"
          >Identification Number</label
        >
        <input
          id="identificationNumber"
          formControlName="identificationNumber"
          pInputText
          [disabled]="isFormSubmitted"
        />
        @if (f['identificationNumber'].touched && f['identificationNumber'].invalid) {
          <div class="p-error">
            @if (f['identificationNumber'].errors?.['required']) {
              <span>Identification Number is required</span>
            }

            @if (f['identificationNumber'].errors?.['maxLengthExceeded']) {
              <span>{{ identificationNumberErrorMessage }}</span>
            }
            @if (f['identificationNumber'].errors?.['eitherBuyerTinOrIdentificationNumberValidator']) {
              <span>Provide either Buyer TIN or Identification number.</span>
            }
          </div>
        }
        @if (identificationNumberinvalidErrorMessage) {
          <span class="p-error">
            {{ identificationNumberinvalidErrorMessage }}
          </span>
        }
      </div>
    </div>

    <!-- Submit Button -->
    @if (!isFormSubmitted) {
      <div class="p-field p-col-12">
        <div class="button-container">
          <button
            type="submit"
            class="ey-button-dark mt-0"
            [disabled]="buyerTinForm.invalid"
            [pTooltip]="buyerTinForm.invalid ? '' : 'Click to verify the TIN with IRBM.'"
            tooltipPosition="right"
          >Validate</button>
        </div>
      </div>
    }
  </div>
</form>
